import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { MainService } from '../main.service';
import { SharedService } from '../shared.service';
import { ApiService } from '../api.service';
@Component({
  selector: 'app-send-sms',
  templateUrl: './send-sms.component.html',
  styleUrls: ['./send-sms.component.scss'],  
})
export class SendSmsComponent implements OnInit {
  sms_text: string = '';
  sms_dial_code: string = '';
  sms_mobile: string = '';
  sms_mobile_numbers: any = [];
  @Input() userId: any;
  @Input() first_name: any;
  @Input() last_name: any;
  @Input() dispute_id = null;
  @Input() drd_id = null;
  @Input() dial_code: any;
  @Input() mobile: any;

  constructor(
    private mainService: MainService,
    public modalRef: BsModalRef,
    public _shared: SharedService,
    public _api: ApiService
  ) {}

  ngOnInit(): void {
    if (this.dial_code && this.mobile) {
      this.sms_dial_code = this.dial_code || '+1';
      this.sms_mobile = this.mobile;
    }
  }

  setSmsDialCode(event: Event) {
    this.sms_dial_code = (event.target as HTMLInputElement).value
      ? (event.target as HTMLInputElement).value
      : '';
  }
  setSmsMobile(event: Event) {
    this.sms_mobile = (event.target as HTMLInputElement).value
      ? (event.target as HTMLInputElement).value
      : '';
  }
  addPhoneNumber() {
    if (this.sms_dial_code && this.sms_mobile) {
      this.sms_mobile_numbers.push({
        dial_code: this.sms_dial_code,
        mobile_no: this.sms_mobile,
      });
      this.sms_dial_code = this.dial_code || '+1';
      this.sms_mobile = '';
    }
  }
  setMessage(event: Event) {
    this.sms_text = (event.target as HTMLInputElement).value
      ? (event.target as HTMLInputElement).value
      : '';
  }

  sendSMS() {
    this._api
      .api(
        {
          mobile: this.sms_mobile_numbers,
          message: this.sms_text,
          user_id: this.userId,
          dispute_id: this.dispute_id,
          drd_id: this.drd_id,
        },
        `user/send_sms`,
        'post'
      )
      .subscribe((res: any) => {
        this.sms_mobile_numbers = [];
        this.sms_text = '';
        this.sms_mobile = '';
        this.sms_dial_code = '';
        if (res.is_error == 0) {
          this._shared.customPopups(res.msg, 0);
        } else {
          this._shared.customPopups(res.msg, 1);
        }
      });
    this.modalRef?.hide();
  }

  removePhoneNumber(i: any) {
    this.sms_mobile_numbers = this.sms_mobile_numbers.filter(
      (d: any, index: any) => index !== i
    );
  }
}
